import {toFloat} from "./NumberUtils";

const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const titleCase = (str?: string) => {
    if(!str) { return ''; }
    return str
        .split(' ')
        .map((s) => {
            if (s.length <= 1) {
                return s.toUpperCase();
            }
            return s[0].toUpperCase() + s.substring(1).toLowerCase();
        })
        .join(' ');
};

const toCurrency = (amount: number | string) => {
    return (
        '$' +
        Number(amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    );
};

const toCurrencyNoDecimals = (amount: number) => {
    return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const toCurrencyRounded = (amount: string) => {
    const roundedAmount = Math.ceil(toFloat(amount));

    return '$' + roundedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const toPercentage = (percent: number, precision = 2) => {
    return parseFloat((percent * 100).toFixed(precision)) + '%';
};

const toFullDate = (date: Date) => {
    const _date = new Date(date);
    return monthNames[_date.getUTCMonth()] + ' ' + _date.getUTCDate() + ' ' + _date.getFullYear();
};

const toFullMonthName = (date: Date) => {
    const _date = new Date(date);
    return monthNames[_date.getUTCMonth()] + ', ' + _date.getFullYear();
};

const toMonthDate = (date: Date) => {
    const _date = new Date(date);
    const day = _date.getUTCDate();
    if (day % 10 === 1) {
        return day + 'st';
    } else if (day % 10 === 2) {
        return day + 'nd';
    } else if (day % 10 === 3) {
        return day + 'rd';
    } else {
        return day + 'th';
    }
};

const cutString = (str: string | undefined, n: number) => {
    return str && str.length > n ? str.slice(0, n - 3) + '...' : str;
};

const toBusinessDayString = (day: string) => {
    const _cnt = parseInt(day, 10);
    return _cnt === 1 ? '1 business day' : _cnt + ' business days';
};

const toPhoneBeautify = (phone: string | undefined) => {
    if (!phone) {
        return null;
    }
    return '+1 (' + phone.slice(0, 3) + ') ' + phone.slice(4);
};

const toClearEmail = (value: string | undefined) => {
    if (!value) {
        return '';
    }
    return value.replace(/\s/g, '');
};

const toClearEID = (value: string | undefined) => {
    if (!value) {
        return '';
    }
    return value.replaceAll(/[^a-zA-Z0-9@_\-+.]/g, '');
};

const formatAddressStreet = (street: string): string => {
    const REGEX_PO_BOX = /^(p[\s.]*o[\s.]*box|post\s*office\s*)\s*(box|bin|b\.?)*\s*(no|num|number|#)*\s*/i;

    if (REGEX_PO_BOX.test(street)) {
        street = street.replace(REGEX_PO_BOX, "P.O. Box ");
        return street.trim();
    }
    return titleCase(street);
};

export {
    titleCase,
    toCurrency,
    toCurrencyNoDecimals,
    toCurrencyRounded,
    toPercentage,
    toFullDate,
    toFullMonthName,
    toMonthDate,
    cutString,
    toBusinessDayString,
    toPhoneBeautify,
    toClearEmail,
    toClearEID,
    formatAddressStreet,
};
